import { useState, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export default function APIDocPage({ pageName }) {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(`/APIDocPages/${pageName}.md`)
      .then((response) => response.text())
      .then((text) => setContent(text));
  }, [pageName]);

  return (
    <div className="user-guide">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        // customize the rendering of images
        components={{
          // Use iframe for video embedding
          img: ({ src, alt }) =>
            alt === "video" ? (
              <iframe
                src={src}
                title="Embedded video"
                allow="fullscreen; autoplay"
                sandbox="allow-scripts allow-same-origin allow-presentation"
                width="900"
                height="506"
                style={{ border: "none" }}
              />
            ) : (
              <img src={src} alt={alt} />
            ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
